import { ETAB_ROUTES } from "@etab/config";
import { ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED } from "@etab/stores/types";
import { ACTION_TRANSITIONS_SET } from "@core/store/types";
import { TRANSITIONS } from "@core/constants";
import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { useRecruitmentCandidatesStore } from "@etab/stores/recruitment-candidates";
import { useCssTransitionsStore } from "@core/store/modules/cssTransitions";

import PermanentFeedbackRoot from "./PermanentFeedback.root.vue";
import RecruitedPage from "./Recruited.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.permanent.feedback.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.permanent.feedback.root.name,
      component: PermanentFeedbackRoot,
      children: [
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.feedback.recruited.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.feedback.recruited.name,
          async beforeEnter(to, from, next) {
            const cssTransitionsStore = useCssTransitionsStore();
            const recruitmentCandidatesStore = useRecruitmentCandidatesStore();
            try {
              LoadingManager.show();
              const demandId = to.params.demandId;
              const demandType = to.params.demandType;

              cssTransitionsStore[ACTION_TRANSITIONS_SET](TRANSITIONS.SLIDE.LEFT);
              await recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED]({
                demandId,
                type: demandType,
              });
              next();
            } catch (error) {
              NotificationsManager.error();
              throw error;
            } finally {
              LoadingManager.hide();
            }
          },
          component: RecruitedPage,
        },
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.feedback.notRecruited.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.feedback.notRecruited.name,
          async beforeEnter(to, from, next) {
            const cssTransitionsStore = useCssTransitionsStore();
            const recruitmentCandidatesStore = useRecruitmentCandidatesStore();
            try {
              LoadingManager.show();
              const demandId = to.params.demandId;
              const demandType = to.params.demandType;

              cssTransitionsStore[ACTION_TRANSITIONS_SET](TRANSITIONS.SLIDE.LEFT);
              await recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED]({
                demandId,
                type: demandType,
              });
              next();
            } catch (error) {
              NotificationsManager.error();
              throw error;
            } finally {
              LoadingManager.hide();
            }
          },
          component: RecruitedPage,
        },
      ],
    },
  ];
}
